import React, {useEffect, useState} from "react";

import applicablePolicyTableDataSource from "__mocks__/applicablePolicyTable";
import {Checkbox, Popconfirm, Row, Table} from "antd";
import {ColumnsType} from "antd/es/table";
import useFetch from "hooks/useFetch";
import {medicalExaminationService} from "api";

const getIn = (e, l) => {
  const obj = l.find(i => i.id === e.id);
  return !!obj;
};

const ApplicablePolicy = props => {
  const [data, setData] = useState<any>(props.appliedPolicy);
  const columns: ColumnsType = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
      align: "center",
      render: (_v, _r, idx) => <>{idx + 1}</>,
    },
    {
      title: "Chính sách áp dụng",
      key: "tenChinhSachBHYT",
      dataIndex: "tenChinhSachBHYT",
      align: "left",
    },
    {
      title: "TT ưu tiên",
      key: "thuTuUuTien",
      dataIndex: "thuTuUuTien",
      align: "right",
      sorter: (a: any, b: any) => a.thuTuUuTien - b.thuTuUuTien,
      render: (value, r, i) => <>{value + 1}</>,
    },
    {
      title: "Áp dụng",
      key: "apDung",
      dataIndex: "apDung",
      align: "center",
      render: (value, record, idx) => <Checkbox checked={value}></Checkbox>,
    },
  ];

  useEffect(() => {
    setData(props.appliedPolicy);
  }, [props]);

  return (
    <Row>
      <Table columns={columns} dataSource={data} pagination={false} />
    </Row>
  );
};

export default ApplicablePolicy;
